import { ScrollingModule } from '@angular/cdk/scrolling';
import { Component, computed, inject, output, signal } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

import { ListResponse } from '@models/helpers';
import { SearchModel } from '@models/search';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { VirtualListComponent } from '@shared/components/virtual-list';
import { PAGE_SIZE_OPTIONS } from '@shared/consts';
import { NotFoundComponent } from '@system/not-found/not-found.component';
import { SearchFilterComponent } from '@system/search/filter/search-filter.component';
import { SearchResultCardComponent } from '@system/search/result/card/search-result-card.component';
import { SearchService } from '@system/search/service/search.service';
import { SearchStore } from '@system/search/store';
@Component({
  selector: 'cipo-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
  imports: [
    ScrollingModule,
    MatPaginatorModule,
    TranslateModule,
    SearchFilterComponent,
    SearchResultCardComponent,
    NotFoundComponent,
    FlexLayoutModule,
  ],
})
export class SearchResultComponent extends VirtualListComponent<SearchModel> {
  private readonly searchService = inject(SearchService);
  private readonly searchStore = inject(SearchStore);

  viewAll = output<void>();
  documentOpened = output<void>();

  pageSize = signal(PAGE_SIZE_OPTIONS.default[1]);
  haveItems = computed(() => this.recordsCount() > 0);
  haveSearchedText = computed(() => !!this.searchStore.searchText()?.trim());

  readonly MAX_SKELETONS = computed(() =>
    this.userStore.userData()?.loadMore ? [1] : Array.from({ length: 5 }, (_, i) => i + 1),
  );

  public onFilterChanges() {
    this.refreshList();
  }

  loadItems(page: number, pagesize: number): Observable<ListResponse<SearchModel>> {
    const searchText = this.searchStore.searchText();
    if (!searchText?.trim()) return of();

    const { moduleIds, contractId, startDate, endDate, matchAll, statusTypes } = this.searchStore.filter();

    return this.searchService.search({
      searchText,
      searchFilter: {
        userId: this.userStore.userData().id,
        contractId,
        moduleIds,
        startDate,
        endDate,
        matchAll,
        statusTypes,
      },
      searchPagination: { page, pagesize },
    });
  }

  virtualTrackBy(index: number, item: SearchModel): string | number {
    return item?.entityInstanceId ?? index;
  }
}
